import { usePostHog } from "@posthog/react";
import { getLinks } from "@src/handlers/handleApi";
import { useAppStore } from "@src/store";
import { type FC, useState } from "react";
import { useNavigate } from "react-router";

const InputForm: FC = () => {
  const navigate = useNavigate();
  const posthog = usePostHog();
  const error = useAppStore((state) => state.error);
  const setError = useAppStore((state) => state.setError);
  const [loading, setLoading] = useState<boolean>(false);

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const code = (event.target as HTMLFormElement)[0] as HTMLInputElement;
    const codeValue = code.value;
    setLoading(true);

    posthog?.capture("rewards_code_submitted", {
      rewards_code: codeValue,
    });

    try {
      const res = await getLinks(codeValue, setLoading);

      if (res && (res.tbURL || res.rqURL)) {
        posthog?.identify(res.GroupCode as string, {
          rewards_code: codeValue,
        });
        posthog?.capture("rewards_code_validated", {
          rewards_code: codeValue,
          group_code: res.GroupCode as string,
          has_blazers_link: !!res.tbURL,
          has_rose_quarter_link: !!res.rqURL,
        });
        void navigate("home", { state: res });
      } else {
        posthog?.capture("rewards_code_invalid", {
          rewards_code: codeValue,
        });
        setError(true);
      }
    } catch (err) {
      console.log("Error: ", err);
      posthog?.capture("rewards_code_invalid", {
        rewards_code: codeValue,
      });
      posthog?.captureException(err);
      setError(true);
    }
  };

  return (
    <form
      className="mx-auto mt-4 flex overflow-hidden rounded-[var(--border-radius)] transition-shadow duration-250 focus-within:shadow-[var(--shadow-lg)] max-[430px]:flex-col max-[430px]:gap-2"
      onSubmit={(event) => handleLogin(event)}
      onError={() => setError(true)}
      data-error={error}
    >
      <input
        type="text"
        name="code"
        className="flex-[2] appearance-none border-0 bg-[#eee] px-4 py-4 font-sans text-base outline-none max-[767px]:text-lg max-[430px]:w-full max-[430px]:flex-none"
        placeholder="Enter Rewards Code"
        required
        pattern=".*\S.*"
      />
      <input
        type="submit"
        className="flex-1 appearance-none cursor-pointer border-0 bg-[image:var(--bg-gradient)] px-2 py-4 font-sans text-base font-medium uppercase tracking-wide text-white hover:bg-[var(--color-red)] max-[767px]:text-lg max-[430px]:w-full max-[430px]:flex-none"
        value={`${loading ? "Loading..." : "Apply"}`}
      />
    </form>
  );
};

export default InputForm;
